// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__f3bDb","tableRow":"styles_tableRow__3bBdZ","sorted":"styles_sorted__1mRg0","active":"styles_active__2tJjl","notActive":"styles_notActive__jRiXq"};